import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/dashboard/Sidebar";
import TopBar from "@/components/dashboard/TopBar";
import ChatWidget from "@/components/dashboard/ChatWidget";

const TITLES = {
  "/dashboard": "Overview · Command Surface",
  "/dashboard/sales": "Jobs · Dispatch Board",
  "/dashboard/market": "Storm Watch · Live Threats",
  "/dashboard/chat": "AI Sentinel · Conversation",
  "/dashboard/messages": "Inbound · Briefing Requests",
  "/dashboard/leads": "Leads · Find-a-Pro Routing",
  "/dashboard/applications": "Founding Network · Applications",
  "/dashboard/settings": "System Settings",
};

export default function DashboardLayout() {
  const location = useLocation();
  const title = TITLES[location.pathname] || "Dashboard";

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white" data-testid="dashboard-shell">
      <Sidebar />
      <div className="lg:pl-64">
        <TopBar title={title} />
        <main className="p-6 md:p-8">
          <Outlet />
        </main>
      </div>
      {location.pathname !== "/dashboard/chat" && <ChatWidget />}
    </div>
  );
}
